module.exports = __webpack_public_path__ + "img/visa.7f3e6b6a.svg";